<template>
  <div class="menu-box">
    <div class="box">
      <div class="avatar-box">
        <img :src="user.avatar || avatar" alt class="avatar" />
        <div class="selectItem">
          <div class="item" @click="$lfy.Jump.open('/info/0')">{{words.PersonalCenter}}</div>
          <div class="item" @click="Cancellation">{{words.SignOut}}</div>
        </div>
      </div>

      <ul class="item-box">
        <li
          class="item"
          v-for="(item,key) in menu"
          :class="{select:item.path === selfPath}"
          @click="$lfy.Jump.open(item.path)"
          :key="key"
        >
          <div class="icon-box">
            <img :src="item.path === selfPath ? item.icon_select : item.icon" alt />
          </div>
          <div class="textBox" v-if="item.path === selfPath">{{item.text}}</div>
        </li>
      </ul>

      <div class="add-btn" @mouseenter="enter(true)" @mouseleave="enter(false)">
        <img :src="contact" alt class="contact btn_img" />
      </div>
      <div class="contact-box" v-show="contactShow">
        <div class="item wechat">
          <p class="title">微信客服</p>
          <img :src="wechat" alt="微信客服" class="img" />
        </div>
        <div class="item telbox">
          <p class="title">电话客服</p>
          <p class="tel">400 188 6966</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>


<script>
import { mapGetters, mapActions } from "vuex";
export default {
  watch: {
    $route(to, from) {
      console.log(to.path);
      this.selfPath = to.path;
    },
    selfPath() {
      console.log(this.selfPath);
    }
  },
  data() {
    return {
      avatar: require("../../assets/login_192.png"),
      menu: [],
      contact: require("../../assets/contact.png"),
      selfPath: "/",
      wechat: require("../../assets/wechat_code.png"),
      contactShow: false
    };
  },
  methods: {
    ...mapActions(["setUser"]),
    enter(status){
      this.contactShow = status;
    },
    Cancellation() {
      this.setUser({});
      sessionStorage.clear();
      this.$lfy.Jump.Redirect("/");
    }
  },
  created() {
    this.selfPath = this.$route.path;
    this.menu = [
      {
        path: "/main",
        text: this.words.Overview,
        icon: require("../../assets/menu/menu_overview.png"),
        icon_select: require("../../assets/menu/menu_overview_select.png"),
        select: true
      },
      {
        path: "/print",
        text: this.words.print,
        icon: require("../../assets/menu/menu_print.png"),
        icon_select: require("../../assets/menu/menu_print_select.png"),
        select: false
      },
      {
        path: "/scan",
        text: this.words.Home_scan,
        icon: require("../../assets/menu/menu_scan.png"),
        icon_select: require("../../assets/menu/menu_scan_select.png"),
        select: false
      },
      {
        path: "/wallet",
        text: this.words.wallet,
        icon: require("../../assets/menu/menu_wallet.png"),
        icon_select: require("../../assets/menu/menu_wallet_select.png"),
        select: false
      },
      {
        path: "/staff",
        text: this.words.wallet,
        icon: require("../../assets/menu/menu_wallet.png"),
        icon_select: require("../../assets/menu/menu_wallet_select.png"),
        select: false
      },
      {
        path: "/consumption",
        text: this.words.record,
        icon: require("../../assets/menu/menu_record.png"),
        icon_select: require("../../assets/menu/menu_record_select.png"),
        select: false
      }
      /* {
        path: "/message",
        text: this.words.Message,
        icon: require("../../assets/menu/menu_info.png"),
        icon_select: require("../../assets/menu/menu_info_select.png"),
        select: false
      } */
    ];

    if (this.user.is_staff) this.menu.splice(3, 1);
    else this.menu.splice(4, 1);
  },
  computed: {
    ...mapGetters({
      words: "words",
      user: "user"
    })
  }
};
</script>
